import { ref, computed, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-23a4e446"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  key: 0,
  class: "back-box",
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 哔哩哔哩小游戏商品配置 ")], -1));
const _hoisted_5 = {
  class: "optionLabel"
};
const _hoisted_6 = {
  class: "optionDescribtion"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内购ID自动生成规则：包名+内购名称，全小写，不超过32字符", -1));
const _hoisted_8 = {
  class: "card priceCard"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 价格设置 ")], -1));
const _hoisted_10 = {
  class: "flex-list"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "price-box"
}, "CNY", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "*仅支持哔哩哔哩小游戏价格等级", -1));
const _hoisted_13 = {
  class: "flex-list"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "*开启后该商品自动调整为测试价格", -1));
const _hoisted_15 = {
  class: "flex-list"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "price-box"
}, "CNY", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "*最低测试价格为1元", -1));
const _hoisted_18 = {
  key: 0,
  class: "submitBlock"
};
const _hoisted_19 = {
  class: "selectBox"
};
import useDetailHooks from './hooks/useDetailHooks';
import useManualProdId from './hooks/useManualProdId';
import RecordDrawer from './components/RecordDrawer.vue';
import { cloneDeep } from 'lodash';
import { queryGoods, addGoods, updGoods, queryPkgInfo, queryBasicPlanSelections, translator } from '@/api/goodsSetting';
import { useRoute, useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { awaitWrap, getNode, OK, reportEvent } from '@/common';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'bilibiliGameDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      huaweiProdTypeOptions
    } = useDetailHooks();
    const typeDisabled = ref(true);
    const disabled = ref(false);
    const detailFormInit = {
      os: 1,
      prodType: undefined,
      productNativeInfo: '',
      remark: '',
      prodId: '',
      zoneId: '',
      testStatus: false,
      price: '1',
      testPrice: '1',
      pkg: ''
    };
    const recordVisible = ref(false);
    /** M4：变更记录接口 bizId，优先详情回填的 skuId，否则由 RecordDrawer 内按路由 skuId / id 解析 */
    const recordDrawerBizId = computed(() => {
      var _settingForm$value;
      const sku = (_settingForm$value = settingForm.value) === null || _settingForm$value === void 0 ? void 0 : _settingForm$value.skuId;
      if (sku != null && String(sku).trim() !== '') {
        return String(sku).trim();
      }
      return undefined;
    });
    const queryParams = ref({
      prodChnl: '',
      dbtId: '',
      id: null
    });
    /** 查看态（M3）：路由 type=watch，全表单只读、底部操作区不渲染 */
    const isWatch = computed(() => String(route.query.type || '').toLowerCase() === 'watch');
    /** 编辑态：内购 ID 禁改、不参与校验；隐藏连续创建；保存走 updGoods */
    const isEdit = computed(() => {
      const raw = queryParams.value.id;
      if (raw === undefined || raw === null || raw === '') return false;
      const n = Number(raw);
      return !Number.isNaN(n) && n > 0;
    });
    const prodIdRules = computed(() => {
      if (isEdit.value || isWatch.value) return [];
      return [{
        required: true,
        trigger: ['change', 'blur'],
        validator: validateBlblProdId
      }];
    });
    const saveNext = ref(false);
    const priceOptions = ref([]);
    const myFormRef = ref(null);
    const priceLoading = ref(false);
    const saveLoading = ref(false);
    const settingForm = ref(cloneDeep(detailFormInit));
    const {
      isManualProdId,
      handleProdIdFocus,
      handleProdIdBlur,
      resetManualProdId
    } = useManualProdId(() => settingForm.value.prodId);
    const getDetail = async () => {
      const res = await queryGoods({
        id: Number(queryParams.value.id)
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _res$data$payConfig, _res$data, _res$data2;
        settingForm.value = {
          ...res.data,
          zoneId: (_res$data$payConfig = res.data.payConfig) === null || _res$data$payConfig === void 0 ? void 0 : _res$data$payConfig.zoneId,
          price: (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.officePrices) === null || _res$data === void 0 || (_res$data = _res$data[0]) === null || _res$data === void 0 ? void 0 : _res$data.price,
          testPrice: (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.testPrices) === null || _res$data2 === void 0 || (_res$data2 = _res$data2[0]) === null || _res$data2 === void 0 ? void 0 : _res$data2.price
        };
      }
    };
    const getPkg = async () => {
      const res = await queryPkgInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      });
      typeDisabled.value = false;
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        settingForm.value.pkg = res.data.pkg;
        // 新建态用包名作为内购 ID 前缀；编辑态由 queryGoods 回填 prodId，避免被覆盖
        if (!queryParams.value.id) {
          settingForm.value.prodId = res.data.pkg;
        }
        if (res.data.zoneId != null && res.data.zoneId !== '') {
          settingForm.value.zoneId = res.data.zoneId;
        }
      }
    };
    const getPriceList = async () => {
      priceLoading.value = true;
      const [err, res] = await awaitWrap(queryBasicPlanSelections({
        prodChnl: queryParams.value.prodChnl
      }));
      priceLoading.value = false;
      if (err) return;
      if (res && res.code === OK) {
        var _res$data3;
        priceOptions.value = (_res$data3 = res.data) === null || _res$data3 === void 0 || (_res$data3 = _res$data3.priceLevel) === null || _res$data3 === void 0 ? void 0 : _res$data3.map(item => {
          return {
            label: item === null || item === void 0 ? void 0 : item.name,
            value: item === null || item === void 0 ? void 0 : item.value
          };
        });
      }
    };
    const cancel = () => {
      window.history.go(-1);
    };
    const validateBlblProdId = (_rule, value) => {
      const validType = /^[a-zA-Z0-9_]+([.]{1,}[a-zA-Z0-9_]+){0,}$/;
      const validNumber = /^[a-zA-Z0-9._]{1,32}$/;
      if (!value) {
        return Promise.reject('请填写完整内购ID');
      }
      if (value.length > 32) {
        return Promise.reject('内购ID不得超过32个字符');
      }
      if (!validType.test(value) || !validNumber.test(value)) {
        return Promise.reject('请按照正确格式填写内购ID,32字符以内大小写英文,中间允许出现._符号');
      }
      return Promise.resolve();
    };
    const validateTestPrice = (_rule, value) => {
      if (!settingForm.value.testStatus) {
        return Promise.resolve();
      }
      if (value == null || value === '') {
        return Promise.reject('请选择测试价格');
      }
      const n = parseFloat(String(value));
      if (Number.isNaN(n) || n < 1) {
        return Promise.reject('测试价格不得低于1元');
      }
      return Promise.resolve();
    };
    const save = async () => {
      if (isWatch.value) return;
      myFormRef.value.validate().then(async valid => {
        try {
          if (valid) {
            const fn = isEdit.value ? updGoods : addGoods;
            const params = {
              ...settingForm.value,
              dbtId: queryParams.value.dbtId,
              prodType: settingForm.value.prodType,
              pkg: settingForm.value.pkg,
              prodId: settingForm.value.prodId,
              remark: settingForm.value.remark,
              payConfig: {
                zoneId: settingForm.value.zoneId
              },
              testStatus: settingForm.value.testStatus,
              officePrices: [{
                price: settingForm.value.price,
                currency: 'CNY'
              }],
              testPrices: [{
                price: settingForm.value.testPrice,
                currency: 'CNY'
              }],
              syncCreateIosPlatProd: true,
              prodChnl: queryParams.value.prodChnl
            };
            delete params.rate;
            // 编辑态内购 ID 不参与该校验（M2）
            if (!isEdit.value && params.pkg === params.prodId) {
              return message.error('内购ID不可完全等于包名，请手动补齐内购ID后半部分');
            }
            saveLoading.value = true;
            const res = await fn(params);
            saveLoading.value = false;
            if (res.code === '0') {
              reportEvent({
                eventName: 'element_use',
                properties: {
                  ui_name: '哔哩哔哩小游戏商品配置',
                  element_name: '保存'
                }
              });
              message.success('商品保存成功！');
              if (isEdit.value || !saveNext.value) {
                await router.push({
                  name: 'goodsSetting'
                });
              } else {
                resetManualProdId();
                settingForm.value = {
                  ...cloneDeep(detailFormInit),
                  pkg: settingForm.value.pkg,
                  zoneId: settingForm.value.zoneId,
                  prodId: settingForm.value.pkg
                };
              }
            }
          }
        } catch (error) {
          saveLoading.value = false;
        }
      });
    };
    const validateProdName = (_rule, value) => {
      if (!(value !== null && value !== void 0 && value.length)) {
        return Promise.resolve();
      }
      if (value.length > 32) {
        return Promise.reject('商品信息不得超过32个字符');
      }
      if (/[%&]/.test(value)) {
        return Promise.reject('商品信息不得包含 %、& 等特殊字符');
      }
      return Promise.resolve();
    };
    const changeName = async () => {
      var _settingForm$value2;
      if (disabled.value) return;
      settingForm.value.prodName = (_settingForm$value2 = settingForm.value) === null || _settingForm$value2 === void 0 || (_settingForm$value2 = _settingForm$value2.prodName) === null || _settingForm$value2 === void 0 ? void 0 : _settingForm$value2.trim();
      if (!settingForm.value.prodName) return;
      try {
        const [err, res] = await awaitWrap(translator({
          sourceLang: 'zh-cn',
          sourceText: settingForm.value.prodName,
          targetLang: ['en_Us']
        }));
        if (err) {}
        if (res && res.code === OK) {
          setProdId(res.data.translateList[0].translatedResult);
        }
      } catch (e) {}
    };
    const setProdId = e => {
      e = e.trim();
      if (queryParams.value.id || isWatch.value) return;
      if (isManualProdId.value) return; // 用户主动修改过，后面就不自动根据商品信息拼接
      const pkgStr = settingForm.value.pkg;
      const lengthLimit = 32;
      if (!e.length) {
        settingForm.value.prodId = String(pkgStr).slice(0, lengthLimit);
        return;
      }
      try {
        var _getStr$match;
        let getStr = e.toLowerCase().replace(/\s*/g, '');
        getStr = ((_getStr$match = getStr.match(/[a-z0-9.]/g)) === null || _getStr$match === void 0 ? void 0 : _getStr$match.join('')) || '';
        const countStr = lengthLimit - pkgStr.length - 1;
        const suffix = countStr > 0 ? '.' + getStr.slice(0, countStr) : '';
        settingForm.value.prodId = (pkgStr + suffix).slice(0, lengthLimit);
      } catch (error) {}
    };
    /** 切换默认价格不联动测试价；开启测试价时测试价兜底为 1 元 */
    const handleTestStatusChange = e => {
      if (e) {
        settingForm.value.testPrice = '1';
      }
    };
    onMounted(async () => {
      queryParams.value = {
        ...route.query
      };
      await getPkg();
      await getPriceList();
      if (isWatch.value) {
        disabled.value = true;
      }
      if (isEdit.value) {
        await getDetail();
      }
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref_key: "myFormRef",
        ref: myFormRef,
        model: settingForm.value,
        "label-col": {
          style: 'width: 100px'
        },
        autocomplete: "off"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [queryParams.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = () => {
            _unref(router).back();
          })
        }, {
          default: _withCtx(() => [_createTextVNode(" 返回 ")]),
          _: 1
        }), _createElementVNode("div", {
          class: "record-text",
          onClick: _cache[1] || (_cache[1] = $event => recordVisible.value = true)
        }, "变更记录")])) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_a_form_item, {
          label: "商品类型",
          name: "prodType",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            placeholder: "请选择商品类型",
            class: "inputer",
            value: settingForm.value.prodType,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => settingForm.value.prodType = $event),
            options: _unref(huaweiProdTypeOptions),
            disabled: typeDisabled.value || disabled.value,
            getPopupContainer: _unref(getNode)
          }, {
            option: _withCtx(({
              label,
              describtion
            }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(describtion), 1)]),
            _: 1
          }, 8, ["value", "options", "disabled", "getPopupContainer"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "备注"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "bigInputer",
            value: settingForm.value.remark,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => settingForm.value.remark = $event),
            placeholder: "请输入",
            disabled: disabled.value,
            maxLength: 20
          }, null, 8, ["value", "disabled"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "商品信息",
          name: "prodName",
          rules: [{
            required: true,
            type: 'string'
          }, {
            validator: validateProdName,
            trigger: 'blur'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "bigInputer",
            value: settingForm.value.prodName,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => settingForm.value.prodName = $event),
            placeholder: "请输入商品名称",
            maxLength: 32,
            disabled: disabled.value,
            onBlur: changeName
          }, null, 8, ["value", "disabled"])]),
          _: 1
        }, 8, ["rules"]), _createVNode(_component_a_form_item, {
          label: "内购ID",
          name: "prodId",
          rules: _unref(prodIdRules)
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            class: "inputer",
            value: settingForm.value.prodId,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => settingForm.value.prodId = $event),
            placeholder: "请输入内购ID",
            disabled: _unref(isEdit) || disabled.value,
            onFocus: _unref(handleProdIdFocus),
            onBlur: _unref(handleProdIdBlur)
          }, null, 8, ["value", "disabled", "onFocus", "onBlur"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_hoisted_7]),
            default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
              class: "infoIcon ml8"
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_form_item, {
          label: "默认价格",
          name: "price",
          required: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.price,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => settingForm.value.price = $event),
            options: priceOptions.value,
            placeholder: "选择默认价格",
            disabled: disabled.value
          }, null, 8, ["value", "options", "disabled"]), _hoisted_11, _hoisted_12])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "开启测试价格",
          name: "testStatus"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_a_switch, {
            checked: settingForm.value.testStatus,
            "onUpdate:checked": _cache[7] || (_cache[7] = $event => settingForm.value.testStatus = $event),
            disabled: disabled.value,
            onChange: handleTestStatusChange
          }, null, 8, ["checked", "disabled"]), _hoisted_14])]),
          _: 1
        }), settingForm.value.testStatus ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0,
          label: "测试价格",
          name: "testPrice",
          rules: [{
            validator: validateTestPrice,
            trigger: ['change', 'blur']
          }]
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_a_select, {
            class: "inputer",
            value: settingForm.value.testPrice,
            "onUpdate:value": _cache[8] || (_cache[8] = $event => settingForm.value.testPrice = $event),
            options: priceOptions.value,
            placeholder: "选择测试价格",
            disabled: disabled.value
          }, null, 8, ["value", "options", "disabled"]), _hoisted_16, _hoisted_17])]),
          _: 1
        }, 8, ["rules"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["model"]), !_unref(isWatch) ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_a_button, {
        onClick: cancel
      }, {
        default: _withCtx(() => [_createTextVNode("取 消")]),
        _: 1
      }), _createVNode(_component_a_button, {
        loading: saveLoading.value,
        class: "ml8",
        type: "primary",
        onClick: save,
        disabled: priceLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode(" 保 存 ")]),
        _: 1
      }, 8, ["loading", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_19, [_createVNode(_component_a_checkbox, {
        checked: saveNext.value,
        "onUpdate:checked": _cache[9] || (_cache[9] = $event => saveNext.value = $event)
      }, {
        default: _withCtx(() => [_createTextVNode("连续创建")]),
        _: 1
      }, 8, ["checked"])], 512), [[_vShow, !_unref(isEdit)]])])) : _createCommentVNode("", true), _createVNode(RecordDrawer, {
        visible: recordVisible.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = $event => recordVisible.value = $event),
        "biz-id": _unref(recordDrawerBizId)
      }, null, 8, ["visible", "biz-id"])]);
    };
  }
});